module.exports = __webpack_public_path__ + "media/images/zendesk-9cf44391fdcc5e6e3b8cbc94272303c3.svg";